export enum IndicatorType {
	None = 'None',
	Pending = 'Pending',
	Succeeded = 'Succeeded',
	Failed = 'Failed',
}
